<template>
  <div class="buttonSwitch">
    <b-button
      class="button"
      :variant="getValue ? 'secondary' : 'primary'"
      @click.prevent="getValue = false"
    >
      {{ firstText }}
    </b-button>
    <b-button
      class="button"
      :variant="getValue ? 'primary' : 'secondary'"
      @click.prevent="getValue = true"
    >
      {{ secondText }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    firstText: {
      type: String
    },
    secondText: {
      type: String
    }
  },
  computed: {
    getValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .buttonSwitch{
    display: flex;
    .button{
      width: 120px;
      justify-content: center;
      padding-left: 10px;
      padding-right: 10px;
    }
    .button:nth-child(1){
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .button:nth-child(2){
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>
